import { enumValue } from '@/common/EnumValue'
import MyEnum from '@/common/MyEnum'
import { i18n } from '@/i18n'
import { idSearchFormatter } from '@/utils/strUtil'
import { toMap } from '@/utils/objUtil'
const freeze = Object.freeze

export class REVIEW_TYPE_ENUM extends MyEnum {
  static TRACK = enumValue(1, '歌曲')
  static CP = enumValue(2, '版权')
}

export class MATERIAL_ENUM extends MyEnum {
  static TRACK = enumValue(1, '歌曲')
  static KTRACK = enumValue(2, '伴奏')
  static MV = enumValue(3, 'MV')
}

export class MATERIAL_FILE_ENUM extends MyEnum {
  static TRACK = enumValue(1, '歌曲文件')
  static AUTH = enumValue(2, '授权文件')
  static SONGLIST = enumValue(3, '歌单信息文件')
  static WNGPAN = enumValue(4, '网盘链接')
}

export class CopyrightTypeMap extends MyEnum {
  static WEI_ZHI = enumValue(0, '无')
  static BAN_QUAN_BU = enumValue(1, '内容合作部')
  static FREE = enumValue(2, '免费授权')
  static YE_GUAN_BU = enumValue(3, '生态合作中心')
  static YIN_YUE_REN = enumValue(4, '音乐人开平')
  static YIN_YUE_REN_BD = enumValue(5, '音乐人BD')
  static ZI_QIAN_YUE = enumValue(6, '平台自签约')
  static CREATOR_CENTER = enumValue(7, '创作者中心')
  static KUGOU_UP = enumValue(8, '酷狗主播开平')
  static LONG_ALBUM_BU = enumValue(9, '长音频版权部')
}

export const signPlatformMap = freeze({
  1: 'QQ音乐',
  2: '全民K歌',
  3: '酷狗',
  4: '酷我',
  5: '爱听卓乐',
  6: '懒人听书',
  7: 'MOO',
})

export const signBusinessTeamMap = {
  0: '未知',

  // 内容合作部
  1: '垂类音乐组',
  2: '内地组',
  3: '日韩组',
  4: '欧美组',
  5: '综艺组',
  6: '影视组',
  7: '港台组',
  8: '词曲组',
  9: '三大唱片组',

  // 内容工作室群
  101: '制作家工作室',
  102: '三三四五工作室',
  103: '联合文娱发展部',
  104: '百亿工作室',
  105: '哆咪嗦自制工作室',
  106: '演出合作中心',

  // 音乐人开放平台
  201: '音乐人开放平台',

  // 生态合作中心
  301: '生态合作中心',

  // QQ音乐
  401: 'QQ音乐',

  // 酷狗音乐
  501: '酷狗音乐',

  // 酷我音乐
  601: '酷我音乐',

  // 一立特工作室
  701: '一立特工作室',

  // 长音频版权管理部
  801: '有声书版权中心',
  802: '非有声书版权中心',
  803: '独立端版权中心',
  804: '播客生态中心',
  805: '独立端生产制作部',
  806: '酷狗主播开平',
  807: '超级IP组',

  // 全民K歌
  901: '全民K歌',

  1001: 'MOO音乐',
}

export const onlyTypeMap = {
  0: '未知',
  1: '无首发',
  2: '短期首发',
  3: '长期首发',
}

export const signFormMap = {
  0: '未确定',
  1: '入驻协议',
  2: '正式合约',
  3: '授权书',
  4: '邮件授权',
}

export const tmePartyMap = freeze({
  0: '无',
  1005: '腾讯音乐（北京）有限公司',
  1008: '腾讯音乐娱乐（上海）有限公司',
  1016: '腾讯音乐娱乐（珠海）有限公司',
  1024: '海南腾讯音乐娱乐信息技术有限公司',
  1043: '腾讯音乐娱乐（深圳）有限公司',
  1003: 'Tencent Music Entertainment Hong Kong Limited',
  1045: '腾讯音乐娱乐科技（深圳）有限公司'
})

export const settleTypeMap = freeze({
  1: '一次性费用+分成',
  2: '一次性费用',
  3: '纯分成',
  5: 'Rolling Advance（滚动预付）',
  6: '预付+分成（可延期抵扣-固定期限）',
  7: '预付+分成（通用）',
  8: '预付+分成（可延期抵扣-抵扣完为止）',
  9: '预付+分成（工作室）',
  10: '纯分成（工作室）',
  11: '无结算',
})

export const contentTypeMap = freeze({
  0: '未知',
  1: '垂类',
  2: '华语内地',
  3: '日韩',
  4: '欧美',
  5: '综艺',
  6: '影视',
  7: '港台',
  8: '词曲',
  9: '对外合作',
  10: '内容自制',
  11: '艺人合作',
  12: 'K歌国际',
  21: 'QQ音乐',
  22: '星途工作室',
  23: '新鲜制造工作室',
  24: '哆咪嗦工作室',
  31: '生态运营管理一组',
  32: '生态运营管理二组',
  51: '音乐人开放平台',
  52: '生态合作中心',
})

export const buyTypeMap = freeze({
  0: '默认',
  1: '新签',
  2: '数专',
  3: '普专',
  4: '曲库',
  5: '厂牌',
  6: '词曲曲库',
})

export const buyStatusMap = freeze({
  0: '未知',
  1: '在途',
  2: '不采买',
  3: '采买完成'
})

export const trackStatusList = freeze([
  {
    id: -1,
    name: '商务提交',
    disabled: true
  },
  {
    id: 0,
    name: '歌曲入库中',
    disabled: false
  },
  {
    id: 1,
    name: '版权审核中',
    disabled: false
  },
  {
    id: 2,
    name: '付费配置中',
    disabled: true
  },
  {
    id: 3,
    name: '已上架',
    disabled: true
  },
])
export const trackStatusMap = toMap(trackStatusList)

export const cpStatusList = freeze([
  {
    id: -1,
    name: '商务提交',
    disabled: true
  },
  {
    id: 0,
    name: '法务确权中',
    disabled: false
  },
  {
    id: 1,
    name: '版权审核中',
    disabled: false
  },
  {
    id: 2,
    name: '已审核',
    disabled: true
  }
])
export const cpStatusMap = toMap(cpStatusList)

export const taskSearchTypeMap = {
  taskName__contains: {
    label: i18n.t('cpTask.taskName'),
    placeholder: i18n.t('cpTask.taskNamePlaceholder'),
  },
  idList: {
    label: i18n.t('cpTask.taskId'),
    placeholder: i18n.t('cpTask.taskIdPlaceholder'),
    formatter: idSearchFormatter
  },
}

export const typeMap = {
  0: '未知',
  1: '合作公司',
  2: '免费授权',
  3: '优选内容B',
  4: '优选内容A',
  5: '优选内容C'
}

export const authTypeList = [
  {
    id: 1,
    name: '录音权',
    disabled: false
  },
  {
    id: 2,
    name: '词版权',
    disabled: false,
  },
  {
    id: 3,
    name: '曲版权',
    disabled: false
  },
  {
    id: 5,
    name: 'MV版权',
    disabled: false
  },
  {
    id: 4,
    name: '转授权',
    disabled: false,
  },
  {
    id: 6,
    name: '其他',
    disabled: false
  },
  {
    id: 0,
    name: '请选择',
    disabled: true
  }
]

export const authTypeMap = authTypeList.reduce((result, item) => {
  result[item.id] = item.name

  return result
}, {})

export const isFreeMap = {
  0: '否',
  1: '是'
}

export const songsIsOnlyMap = {
  0: '非首发',
  1: '首发',
}

export const canClipMap = {
  0: '否',
  1: '是',
}
export const noLinkMap = {
  0: '否',
  1: '是',
}

export const isAllSongbankMap = {
  0: '否',
  1: '是',
}

export const isOverseaMap = {
  0: '否',
  1: '是',
}

export const srcInReceiverMap = {
  0: '自行使用',
  1: '可转授其他第三方'
}

export const rightCompleteMap = {
  0: '否',
  1: '是'
}
export const canCoverMap = freeze({
  0: '未确定',
  1: '唱片公司确认可翻唱',
  2: '唱片公司确认不可翻唱',
})

export const coverNeedPermissionMap = freeze({
  0: '不需要',
  1: '需要'
})

export const toListFields = ['excludePlatform', 'copyrightArea', 'network', 'cooFactory', 'resaleProduct',
  'authForm', 'authTerminal', 'authProduct', 'authPlatform', 'attr', 'otherRight', 'excludeArea', 'productLimit',
  'terminalLimit', 'formLimit', 'networkLimit', 'settleMethod', 'signPlatform', 'propertyRightLimit', 'application', 'applicationArea']

export const overseaStatusMap = {
  0: '不可海外漫游',
  1: '可以海外漫游',
  2: '唱片公司确认不可海外漫游',
  3: '唱片公司要求海外屏蔽',
  4: '唱片公司要求严格合规'
}

export const cooFactoryMap = {
  1: 'TOB(转授权内容给硬件厂商)',
  2: 'TOC(APP内置)',
}

export const attrMap = {
  1: '代理',
  2: '普通',
  3: '其他平台转售',
  4: '自有',
  5: '其他'
}

export const wmAuthTypeMap = {
  0: '未确定',
  1: '词曲签约',
  2: '录音授权带词曲'
}

export const isVirtualMap = {
  0: '否',
  1: '是'
}

export const belongToMap = {
  0: '集团代理',
  1: '集团买断',
  2: '优选代理',
  3: '优选买断',
  4: '公版',
}

export const defaultAuthorizee = [{
  value: '85775 -@- 腾讯音乐娱乐集团'
}]

export const validMap = freeze({
  0: '否',
  1: '是'
})

export const companyTypeMap = freeze({
  0: '未知',
  1: '合作公司',
  2: '免费授权',
  3: '优选内容B',
  4: '优选内容A',
  5: '优选内容C'
})

export const contractTypeMap = freeze({
  1: '新签',
  2: '续约',
  3: '续约+新签',
})

export const insertTypeMap = freeze({
  1: '人工上传物料',
  2: '系统自动上传',
  3: '厂牌自助平台上传'
})

export const batchAuthTypeMap = freeze({
  1: '签约',
  2: '自制',
  3: '免费'
})

export const paymentModeMap = freeze({
  1: '免费',
  2: '1.0',
  3: '2.0',
  4: '3.0',
  5: '2.0转3.0',
})

export const settleMethodMap = freeze({
  1: '纯分成',
  2: '预付+分成（抵扣）',
  3: '预付+分成（不抵扣）',
  4: '买断',
  5: '保底分成',
  6: '免费授权不结算',
})

export const copyrightAreaMap = freeze({
  0: '中国大陆',
  1: '中国香港',
  2: '中国台湾',
  3: '中国澳门',
  4: '马来西亚',
  5: '泰国',
  6: '印尼',
  7: '亚洲地区',
  8: '全世界',
  9: '南非',
  10: '缅甸',
  11: '菲律宾',
  12: '印度',
  13: '新加坡',
  14: '越南',
  15: '文莱',
  16: '俄罗斯',
  17: '美国',
  18: '加拿大'
})

export const authTerminalMap = freeze({
  1: 'PC电脑',
  2: '平板电脑',
  3: '手机',
  4: '车载电视',
  5: '智能音响',
  6: '机顶盒',
  7: 'MPEG4播放器',
  8: '航空器',
  9: '电视机',
  10: '智能电视',
  11: '现有及新增',
  12: '智能耳机',
  13: '实体KTV机器',
  14: '酷我无线蓝牙耳机',
  15: '酷我音箱',
  16: '酷我儿童故事机',
  17: '智能手表',
  18: '智能家居',
})

export const authProductTreeList = freeze([
  {
    id: 'QQ+TX',
    label: 'Q音+TX系',
    disabled: false,
    children: [
      {
        id: '1',
        label: 'QQ音乐',
        disabled: false,
      },
      {
        id: '2',
        label: '全民K歌',
        disabled: false,
      },
      {
        id: '6',
        label: '企鹅FM',
        disabled: false,
      },
      {
        id: '7',
        label: '微视',
        disabled: false,
      },
      {
        id: '8',
        label: '轻听',
        disabled: false,
      },
      {
        id: '9',
        label: '微信',
        disabled: false,
      },
      {
        id: '10',
        label: 'QQ空间',
        disabled: false,
      },
      {
        id: '11',
        label: '腾讯视频',
        disabled: false,
      },
      {
        id: '19',
        label: '彩虹音乐',
        disabled: false,
      },
      {
        id: '20',
        label: 'QQ',
        disabled: false,
      },
      {
        id: '35',
        label: 'MOO',
        disabled: false,
      },
      {
        id: '36',
        label: 'Q音宝贝',
        disabled: false,
      },
      {
        id: '37',
        label: 'Q音铃声',
        disabled: true,
      },
      {
        id: '38',
        label: '音兔',
        disabled: false,
      },
      {
        id: '39',
        label: '腾讯时光',
        disabled: true,
      },
      {
        id: '40',
        label: 'yoo视频',
        disabled: true,
      },
      {
        id: '52',
        label: 'fan直播',
        disabled: false,
      },
      {
        id: '71',
        label: 'JOOX',
        disabled: false,
      },
    ]
  },
  {
    id: 'KG',
    label: '酷狗系',
    disabled: false,
    children: [
      {
        id: '3',
        label: '酷狗',
        disabled: false,
      },
      {
        id: '12',
        label: '繁星（酷狗）直播',
        disabled: false,
      },
      {
        id: '16',
        label: '5SING',
        disabled: false,
      },
      {
        id: '17',
        label: '酷FM',
        disabled: true,
      },
      {
        id: '26',
        label: '酷狗唱唱',
        disabled: false,
      },
      {
        id: '27',
        label: '酷狗KTV',
        disabled: true,
      },
      {
        id: '28',
        label: '酷狗铃声',
        disabled: false,
      },
      {
        id: '29',
        label: '酷狗直播伴侣',
        disabled: false,
      },
      {
        id: '30',
        label: '短酷',
        disabled: true,
      },
      {
        id: '31',
        label: '巴卟巴卟',
        disabled: true,
      },
      {
        id: '32',
        label: '1822',
        disabled: true,
      },
      {
        id: '33',
        label: '海兔故事',
        disabled: true,
      },
      {
        id: '34',
        label: 'Viper HIFI',
        disabled: false,
      },
      {
        id: '41',
        label: '酷狗游戏盒',
        disabled: true,
      },
      {
        id: '42',
        label: '哄你睡',
        disabled: true,
      },
      {
        id: '43',
        label: '酷秀美女视频',
        disabled: true,
      },
      {
        id: '56',
        label: '酷狗音乐大字版',
        disabled: false,
      },
      {
        id: '57',
        label: '酷狗音乐概念版',
        disabled: false,
      },
      {
        id: '58',
        label: '酷狗音乐儿童版',
        disabled: false,
      },
      {
        id: '59',
        label: '酷狗儿歌',
        disabled: false,
      },
      {
        id: '60',
        label: '酷哇',
        disabled: false,
      },
      {
        id: '61',
        label: '第九音',
        disabled: false,
      },
      {
        id: '62',
        label: '音音直播',
        disabled: false,
      },
      {
        id: '63',
        label: 'cosama',
        disabled: false,
      },
      {
        id: '64',
        label: '幻音',
        disabled: false,
      },
      {
        id: '65',
        label: '品歌',
        disabled: false,
      },
      {
        id: '66',
        label: '酷狗唱唱斗歌版',
        disabled: false,
      },
      {
        id: '67',
        label: '动来电',
        disabled: false,
      },
      {
        id: '68',
        label: '炫壁纸',
        disabled: false,
      },
      {
        id: '69',
        label: '鱼声（酷群）',
        disabled: false,
      },
      {
        id: '70',
        label: '浮浮雷达',
        disabled: false,
      },
      {
        id: '76',
        label: '酷狗DJ',
        disabled: false,
      },
      {
        id: '77',
        label: '迷思音乐',
        disabled: false,
      },
      {
        id: '78',
        label: '歌叽歌叽',
        disabled: false,
      },
      {
        id: '79',
        label: '竖屏MV',
        disabled: false,
      },
      {
        id: '80',
        label: '扇宝',
        disabled: false,
      },
      {
        id: '81',
        label: '酷次元',
        disabled: false,
      },
      {
        id: '82',
        label: '瞭天',
        disabled: false,
      },
      {
        id: '83',
        label: '独恋',
        disabled: false,
      },
      {
        id: '84',
        label: '成双',
        disabled: false,
      },
      {
        id: '85',
        label: '音速达',
        disabled: false,
      }
    ]
  },
  {
    id: 'KW',
    label: '酷我系',
    disabled: false,
    children: [
      {
        id: '4',
        label: '酷我',
        disabled: false,
      },
      {
        id: '13',
        label: '聚星（酷我）直播',
        disabled: false,
      },
      {
        id: '14',
        label: '酷我K歌',
        disabled: false,
      },
      {
        id: '21',
        label: '酷我听书',
        disabled: false,
      },
      {
        id: '22',
        label: '2469',
        disabled: false,
      },
      {
        id: '23',
        label: '酷我BOOM',
        disabled: false,
      },
      {
        id: '24',
        label: '酷我电台',
        disabled: false,
      },
      {
        id: '25',
        label: '酷我视频',
        disabled: false,
      },
      {
        id: '44',
        label: '全民舞指',
        disabled: true,
      },
      {
        id: '45',
        label: '脸红',
        disabled: true,
      },
      {
        id: '46',
        label: '翻茄音乐',
        disabled: false,
      },
      {
        id: '53',
        label: '陌探直播',
        disabled: true,
      },
      {
        id: '54',
        label: 'bulubulu2496',
        disabled: true,
      },
      {
        id: '55',
        label: 'bulubulu',
        disabled: true,
      },
      {
        id: '72',
        label: '波点音乐',
        disabled: false,
      },
      {
        id: '73',
        label: '玩钢琴',
        disabled: false,
      },
      {
        id: '74',
        label: 'easy piano',
        disabled: false,
      },
      {
        id: '75',
        label: '声播',
        disabled: false,
      },
      {
        id: '86',
        label: '豆瓣FM',
        disabled: false,
      },
    ]
  },
  {
    id: 'LR',
    label: '懒人系',
    disabled: false,
    children: [
      {
        id: '48',
        label: '懒人听书',
        disabled: false,
      },
      {
        id: '49',
        label: '芽芽故事',
        disabled: false,
      },
      {
        id: '50',
        label: '懒人关联产品',
        disabled: false,
      },
      {
        id: '51',
        label: '懒人极速版',
        disabled: false,
      },
    ]
  },
  {
    id: 'AT',
    label: '爱听卓乐',
    disabled: false,
    children: [
      {
        id: '5',
        label: '爱听卓乐',
        disabled: false,
      }
    ]
  },
  {
    id: 'YX',
    label: '游戏产品',
    disabled: false,
    children: [
      {
        id: '18',
        label: '游戏产品',
        disabled: false,
      }
    ]
  },
  {
    id: 'OTHER',
    label: '甲方及其关联公司所有/运营/管理其他产品/平台等',
    disabled: false,
    children: [
      {
        id: '47',
        label: '现有+新增',
        disabled: false,
      },
      {
        id: '87',
        label: '甲方及其关联公司所有/运营/管理其他产品/平台等',
        disabled: false,
      }
    ]
  }
])
export const authProductMap = freeze(authProductTreeList.flatMap(v => v.children).reduce((res, cur) => {
  res[cur.id] = cur.label
  return res
}, {}))

export const authPlatformMap = freeze({
  1: '全PC网站',
  2: '全PC客户端',
  3: '全移动端APP',
  4: '小程序',
  5: 'H5',
  6: '快应用',
})

export const excludePlatformMap = freeze({
  1: '运营商',
  2: '硬件厂商',
  3: '其他'
})

export const onlyWholeTimeMap = freeze({
  0: '按天数',
  1: '授权期内'
})

export const authFormList = freeze([
  {
    id: 1,
    name: '在线收听服务',
    disabled: false
  },
  {
    id: 2,
    name: '下载服务',
    disabled: false
  }, {
    id: 5,
    name: '网页/个人空间背景音乐定制',
    disabled: false
  }, {
    id: 6,
    name: '互联网卡拉OK',
    disabled: false
  }, {
    id: 7,
    name: '音乐片段',
    disabled: false
  }, {
    id: 8,
    name: '客户端背景音乐内置',
    disabled: false
  }, {
    id: 9,
    name: '在线游戏背景音乐',
    disabled: false
  }, {
    id: 10,
    name: '歌词翻译',
    disabled: false
  }, {
    id: 13,
    name: '视频背景音乐',
    disabled: false
  }, {
    id: 16,
    name: '互联网来电通话铃声或背景音',
    disabled: false
  }, {
    id: 17,
    name: '在线直播',
    disabled: false
  }, {
    id: 18,
    name: '在线表演',
    disabled: false
  }, {
    id: 19,
    name: 'MV在线播放业务',
    disabled: false
  }, {
    id: 20,
    name: '付费数字专辑',
    disabled: false
  }, {
    id: 21,
    name: '付费缓存',
    disabled: false
  }, {
    id: 22,
    name: '用户点歌',
    disabled: false
  }, {
    id: 23,
    name: '现有及新增',
    disabled: false
  }, {
    id: 24,
    name: '彩铃',
    disabled: false
  },
  {
    id: 11,
    name: '转售手机硬件厂商',
    disabled: true
  }, {
    id: 12,
    name: '手机白牌',
    disabled: true
  }, {
    id: 3,
    name: '收费点播',
    disabled: true
  }, {
    id: 4,
    name: '收费下载',
    disabled: true
  }, {
    id: 14,
    name: '互联网卡拉OK',
    disabled: true
  }, {
    id: 15,
    name: '在线收听',
    disabled: true
  }
])
export const authFormMap = freeze(authFormList.reduce((result, item) => {
  result[item.id] = item.name

  return result
}, {}))

export const otherRightList = [
  {
    id: 1,
    name: '表演者权利',
    disabled: true
  },
  {
    id: 2,
    name: '录音制作者权利(仅伴奏)',
    disabled: false
  },
  {
    id: 3,
    name: '录音制作者权利',
    disabled: true
  },
  {
    id: 4,
    name: '录音音像制作者权利(MV)',
    disabled: false
  },
  {
    id: 5,
    name: '专辑封面权利',
    disabled: false
  },
  {
    id: 6,
    name: '表演者肖像权利',
    disabled: false
  },
  {
    id: 7,
    name: '复制权',
    disabled: false
  },
  {
    id: 8,
    name: '翻唱权利',
    disabled: false
  },
  {
    id: 9,
    name: '发行权',
    disabled: false
  },
  {
    id: 10,
    name: '出租权',
    disabled: false
  },
  {
    id: 11,
    name: '展览权',
    disabled: false
  },
  {
    id: 12,
    name: '表演权',
    disabled: false
  },
  {
    id: 13,
    name: '广播权',
    disabled: false
  },
  {
    id: 14,
    name: '信息网络传播权',
    disabled: false
  },
  {
    id: 15,
    name: '摄制权',
    disabled: false
  },
  {
    id: 16,
    name: '改编权',
    disabled: false
  },
  {
    id: 17,
    name: '翻译权',
    disabled: false
  },
  {
    id: 18,
    name: '汇编权',
    disabled: false
  },
  {
    id: 19,
    name: '放映权',
    disabled: false
  },
  {
    id: 20,
    name: '应当由著作权人享有的其他权利',
    disabled: false
  },
  {
    id: 21,
    name: '歌手照片著作权',
    disabled: false
  },
  {
    id: 22,
    name: '姓名权',
    disabled: false
  },
  {
    id: 23,
    name: '获酬权',
    disabled: false
  }
]
export const otherRightMap = freeze(otherRightList.reduce((result, item) => {
  result[item.id] = item.name

  return result
}, {}))

export const networkMap = freeze({
  1: '互联网',
  2: '移动互联网',
  3: '有线电视网',
  4: 'IPTV',
  5: '运营商网络',
  6: '现有及新增',
  7: 'OTT',
})

export const canLegalRightsMap = {
  0: '否',
  1: '是',
  2: '是但需确认',
}

export const canAuthMap = {
  0: '否',
  1: '是',
  2: '是但需确认',
}

export const isOnlyMap = {
  0: '否',
  1: '是',
}

export const licenseValidList = [
  {
    id: 0,
    name: '未确定',
    disabled: false
  },
  {
    id: 1,
    name: '符合',
    disabled: false
  },
  {
    id: 2,
    name: '不符合',
    disabled: false
  }
]
export const licenseValidMap = licenseValidList.reduce((result, item) => {
  result[item.id] = item.name

  return result
}, {})

export const copyrightFieldName = freeze({
  Ftask_name: '歌曲/专辑名称',
  Fbuy_sys_id: '采买任务ID',
  Fbuy_type: '采买类型',
  Fcp_company_id: '版权方',
  Fdis_company_id: '外显厂牌方',
  Fcontent_type: '内容组别(合同来源)',
  Fcontract_type: '签约类型',

  // 合同
  Fis_virtual: '是否虚拟合同',
  Fsign_business_team: '签约商务团队',
  Foriginal_copyright_from: '原始授权开始时间',
  Foriginal_copyright_to: '原始授权结束时间',
  Fstatus: '状态',
  Fexclude_platform: '排除平台',
  Fauth_product: '授权产品',
  Fnetword: '传播网络',
  Fcoo_factory: '硬件厂商合作',
  Fauth_form: '授权形式',
  Fauth_terminal: '授权终端',
  Fauth_platform: '授权平台',
  Fother_right: '其他权利',
  Fother_limit: '其他限制',
  Fremarks: '备注',
  Fcopyright_from: '开始时间',
  Fcopyright_to: '结束时间',
  Fis_only: '首发',
  Fcan_auth: '是否可转授权',
  Fcan_clip: '是否可剪辑',
  Fcan_legal_rights: '是否可维权',
  Fnetwork: '传播网络',
  Foversea_status: '是否可海外漫游',
  Fcan_over: '可翻唱',
  Fsrc_in_receiver: '音源直接内置至接收终端',
  Fcover_need_permission: '翻唱需要版权方允许',
  Fcan_cover_from: '翻唱开始时间',
  Fcan_cover_to: '翻唱结束时间',
  Fcopyright_area: '授权区域',
  Fother_right_remarks: '备注信息',
  Fcompany_type: '合同公司类型',
  Fcopyright_type: '合同来源',
  Fauthorizer: '授权方',
  Foriginal_obligee: '原始权利人',
  Fattr: '合约属性',
  Fcontract: '合同编号',
  Fauth_type: '合同类型',
  Fwm_auth_type: '词曲授权类型',
  Flicense_valid: '符合维权条件',
  Fis_free: '免费授权合同',
  Fis_all_songbank: '是否全曲库',
  Fright_complete: '是否完整',
  Fno_link: '是否禁止\\限制链接',
  Fnext_operator: '处理人',
  Foperator: '当前处理人',
  remarks: '备注',
  Fdiff_copyright_id: '曲库差异合同ID',
  Fexclude_area: '排除授权区域',
  Fexclude_area_terms: '排除授权区提交',
  Fproduct_limit: '授权产品限制',
  Fproduct_limit_terms: '授权产品限制条件',
  Fterminal_limit: '授权终端限制',
  Fterminal_limit_terms: '授权终端限制条件',
  Fform_limit: '授权形式限制',
  Fform_limit_terms: '授权形式限制条件',
  Fnetwork_limit: '传播网络限制',
  Fnetwork_limit_terms: '传播网络限制条件',
  Fsettle_method: '结算方式',
  Fbusiness_broker: '商务对接人',
  Flast_lawyer: '复核法务',
  Fsign_platform: '签约平台',
  Fonly_whole_time: '首发时间模式',
  Fonly_duration: '首发天数',
  Fauthorizee: '当前被授权主体',
})
export const copyrightFieldToDict = freeze({
  Fexclude_platform: 'excludePlatformMap',
  Fauth_product: 'authProductMap',
  Fnetwork: 'networkMap',
  Fcoo_factory: 'cooFactoryMap',
  Fauth_form: 'authFormMap',
  Fauth_terminal: 'authTerminalMap',
  Fauth_platform: 'authPlatformMap',
  Fother_right: 'otherRightMap',
  Fis_only: 'isOnlyMap',
  Fcan_auth: 'canAuthMap',
  Fcan_clip: 'canClipMap',
  Fcan_legal_rights: 'canLegalRightsMap',
  Foversea_status: 'overseaStatusMap',
  Fcan_over: 'canCoverMap',
  Fcover_need_permission: 'coverNeedPermissionMap',
  Fattr: 'attrMap',
  Fauth_type: 'authTypeMap',
  Fwm_auth_type: 'wmAuthTypeMap',
  Flicense_valid: 'licenseValidMap',
  Fis_free: 'isFreeMap',
  Fis_all_songbank: 'isAllSongbankMap',
  Fright_complete: 'rightCompleteMap',
  Fno_link: 'noLinkMap',
  Fcompany_type: 'typeMap',
  Fcopyright_type: 'copyrightTypeMap',
  Fexclude_area: 'settleMethodMap',
  Fproduct_limit: 'authProductMap',
  Fterminal_limit: 'authTerminalMap',
  Fform_limit: 'authFormMap',
  Fnetwork_limit: 'networkMap',
  Fsettle_method: 'settleMethodMap',
  Fsrc_in_receiver: 'srcInReceiverMap',
  Fsign_platform: 'signPlatformMap',

  Fcontent_type: 'contentTypeMap',
  Fcontract_type: 'contractTypeMap',
  Fbuy_type: 'buyTypeMap',
})
